<template>
  <div id="app" class="App">
    <Layout />
    <Spinner class="spinner" full text="cargando..." :visible="isVisible" />
  </div>
</template>

<script>
import { Spinner } from 'daas-components';

import { Layout } from './views';

export default {
  name: 'App',
  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    controlSpinner() {
      this.isVisible = false;
    },
  },
  components: {
    Layout,
    Spinner,
  },
  mounted() {
    setTimeout(() => {
      this.controlSpinner();
    }, 1000);
  },
};
</script>

<style lang="scss">
@import './styles/App';

.App {
  padding: 0;
  margin: 0;
}
</style>
